import { apiRequest } from './api'
import type {
  Prompt,
  ListPromptsParams,
  ListPromptsResponse,
  CreatePromptData,
  UpdatePromptData,
} from '@/types'

// List prompts with optional filtering and pagination
export async function listPrompts(
  params?: ListPromptsParams
): Promise<ListPromptsResponse> {
  const queryParams = new URLSearchParams()

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.set(key, String(value))
      }
    })
  }

  const queryString = queryParams.toString()
  const url = queryString ? `/prompts/list?${queryString}` : '/prompts/list'
  return apiRequest<ListPromptsResponse>(url)
}

// Get single prompt by ID
export async function getPrompt(id: string): Promise<Prompt> {
  return apiRequest<Prompt>(`/prompts/get/${encodeURIComponent(id)}`)
}

// Create new prompt
export async function createPrompt(data: CreatePromptData): Promise<Prompt> {
  return apiRequest<Prompt>('/prompts/create', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

// Update prompt
export async function updatePrompt(
  id: string,
  data: UpdatePromptData
): Promise<Prompt> {
  return apiRequest<Prompt>(`/prompts/update/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}

// Activate prompt (deactivates others with same use_case)
export async function activatePrompt(id: string): Promise<Prompt> {
  return apiRequest<Prompt>(`/prompts/activate/${encodeURIComponent(id)}`, {
    method: 'POST',
  })
}
